<script setup lang="ts">
import type { NuxtError } from '#app'
definePageMeta({
  layout: 'blank',
  public: true,
})

defineProps<{ error: NuxtError }>()

const { loggedIn, clear } = useUserSession()

const onLogout = async () => {
  await clear()
  navigateTo('/welcome')
}
</script>

<template>
  <main class="h-screen">
    <div class="flex h-full items-center justify-center">
      <div class="pb-4 text-center">
        <p class="text-primary mb-4 text-xl">{{ error.statusCode }}</p>

        <h1 class="text-muted text-4xl">{{ error.statusMessage || 'Oops' }}</h1>

        <p class="text-muted text-4xl">{{ error.message }}</p>

        <template v-if="loggedIn">
          <UButton to="/dashboard" class="mt-4">Go back to home</UButton>
          <UButton class="mt-4" @click="onLogout">Logout</UButton>
        </template>

        <UButton v-else to="/welcome" class="mt-4">Clear error</UButton>
      </div>
    </div>
  </main>
</template>
